module.exports = __webpack_public_path__ + "static/media/storeIcons.3c54b906.svg";